import { DefectPriority } from "../../types/DefectPriority";

export const getDefectSummaryAggregates = (summaries: any) => {
    const defectsTotal = summaries.length;
    let highPriorityTotal = 0;
    let mediumPriorityTotal = 0;
    let lowPriorityTotal = 0;

    summaries.forEach((summary: any) => {
        if (summary.priority === DefectPriority.high) highPriorityTotal++;
        if (summary.priority === DefectPriority.medium) mediumPriorityTotal++;
        if (summary.priority === DefectPriority.low) lowPriorityTotal++;
    });

    return {
        defectsTotal,
        highPriorityTotal,
        mediumPriorityTotal,
        lowPriorityTotal
    };
};

export const getFilteredDefectCounts = (keywordSearch: string, filteredDefects: any) => {
    if (!keywordSearch?.trim()) return filteredDefects;
    
    const searchTerm = keywordSearch.toLowerCase();
    return filteredDefects.filter((defect: any) => 
        [defect.vesselName || defect.shipName,
         defect.vessel?.imo || defect.imo,
         defect.technicalManager,
         defect.type || defect.vessel_type]
        .some(field => field?.toLowerCase().includes(searchTerm))
    );
};